export default __webpack_public_path__ + "static/media/standard-video-challenge.a75ea40a.png";